<template>
  <div class="my-points">
    <div class="points-item" v-for="subItem in showList" :key="subItem.id" @click="toUrl(subItem)">
      <img v-if="subItem.imgUrl && subItem.orderType === 1" class="img-icon" style="object-fit: cover;" :src="subItem.imgUrl.split(',')[0]" alt="" @click.stop="imgPreview(subItem.imgUrl)">
      <img v-else-if="!subItem.imgUrl && subItem.orderType === 1" class="img-icon" :src="projectInfo.brandImg" alt="">
      <img v-else class="img-icon" src="@/assets/images/icon_noimg.png" alt="">
      <div class="item-desc">
        <div class="left-item">
          <!-- 收入 兑换 -->
          <div class="exchange-name txt-ellipsis">{{ [0, 2, 3].includes(subItem.orderType) ? 'Income-' : subItem.orderType === 1 ? 'Redeem-' : '' }}{{ subItem.detailName }}</div>
          <div class="time">Time：{{ subItem.localCreateTime }}</div>
        </div>
        <div class="right-item">{{ [0, 2].includes(subItem.orderType) ? '+' : subItem.orderType === 1 ? '-' : '' }}{{ subItem.totalIntegral }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
export default {
  props: {
    showList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    imgPreview (url) {
      ImagePreview(url.split(','))
    },
    toUrl (params) {
      this.$router.push(`/activity/pointsDetail?scanType=${params.orderType === 0 ? 'activityProduct' : 'activityUpload'}&scanId=${params.id}`)
    }
  }
}
</script>

<style lang="less" scoped>
.my-points {
  flex: 1;
  font-size: 12px;
  .points-item {
    display: flex;
    padding: 10px 0;
    .item-desc {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-left: 10px;
      .left-item {
        height: 63px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .exchange-name {
        width: 200px;
        font-size: 13px;
        font-weight: bold;
      }
      .time {
        color: #aaaaaa;
      }
      .right-item {
        color: #ee541b;
        font-size: 15px;
        font-weight: bold;
      }
    }
    .img-icon {
      width: 58px;
      // height: 63px;
    }
  }
}
</style>
